import { BasicButton } from "@goodgamestudios/asset-globals";
import { BasicController } from "@goodgamestudios/core";
import { ColorMatrix } from "@goodgamestudios/core";
import { MathBase } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";

import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { Poker2SliderEvent } from "../../event/Poker2SliderEvent";

import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class SliderHelper {
    protected sliderMC: MovieClip;
    protected buttonDown: BasicButton;
    protected buttonUp: BasicButton;
    protected buttonSlider: BasicButton;
    protected sliderBar: MovieClip;
    protected currentPos: number = NaN;
    public StepSize: number = 10;
    protected _enabled: boolean = false;
    protected _colorMatrix: ColorMatrix;

    public get enabled(): boolean {
        return this._enabled;
    }

    public set enabled(value: boolean) {
        this._enabled = value;

        if (this._enabled) {
            this.sliderMC.mouseChildren = true;
            this.buttonUp.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickButtonUp));
            this.buttonDown.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickButtonDown));
            this.buttonSlider.addEventListener(MouseEvent.MOUSE_DOWN, this.bindFunction(this.onSliderMouseDown));
            this.sliderBar.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickSlider));
            this.sliderMC.parent.addEventListener(MouseEvent.MOUSE_WHEEL, this.bindFunction(this.onMouseWheel), false, 0, true);
        }
        else {
            this.sliderMC.mouseChildren = false;
            this.buttonSlider.stage.removeEventListener(MouseEvent.PRESS_MOVE, this.bindFunction(this.onSliding));
            this.buttonSlider.stage.removeEventListener(MouseEvent.MOUSE_UP, this.bindFunction(this.onStopSliding));
            this.buttonUp.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickButtonUp));
            this.buttonDown.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickButtonDown));
            this.buttonSlider.removeEventListener(MouseEvent.MOUSE_DOWN, this.bindFunction(this.onSliderMouseDown));
            this.sliderBar.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickSlider));
            this.sliderMC.parent.removeEventListener(MouseEvent.MOUSE_WHEEL, this.bindFunction(this.onMouseWheel));
        }

        if (this._colorMatrix == null) {
            this._colorMatrix = new ColorMatrix();
            this._colorMatrix.desaturate();
        }
        this.sliderMC.filters = (value) ? null : [this._colorMatrix.filter];
    }

    protected onMouseWheel(event: MouseEvent): void {
        // override
    }

    constructor(target: MovieClip) {
        this.currentPos = 0;
        this.sliderMC = target;
        if ("btn_up" in this.sliderMC) {
            this.buttonUp = this.sliderMC["btn_up"];
            this.buttonUp.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickButtonUp));
        }
        if ("btn_down" in this.sliderMC) {
            this.buttonDown = this.sliderMC["btn_down"];
            this.buttonDown.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickButtonDown));
        }
        if ("btn_slider" in this.sliderMC) {
            this.buttonSlider = this.sliderMC["btn_slider"];
            this.buttonSlider.addEventListener(MouseEvent.MOUSE_DOWN, this.bindFunction(this.onSliderMouseDown));
        }
        if ("mc_sliderbar" in this.sliderMC) {
            this.sliderBar = this.sliderMC["mc_sliderbar"];
            this.sliderBar.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickSlider));
        }
    }

    private onSliderMouseDown(event: MouseEvent): void {
        if (!this.buttonSlider.enabled)
            return;
        this.buttonSlider.stage.addEventListener(MouseEvent.PRESS_MOVE, this.bindFunction(this.onSliding));
        this.buttonSlider.stage.addEventListener(MouseEvent.MOUSE_UP, this.bindFunction(this.onStopSliding));
    }
    private onStopSliding(event: MouseEvent): void {
        this.buttonSlider.stage.removeEventListener(MouseEvent.PRESS_MOVE, this.bindFunction(this.onSliding));
        this.buttonSlider.stage.removeEventListener(MouseEvent.MOUSE_UP, this.bindFunction(this.onStopSliding));
    }

    protected onSliding(event: MouseEvent): void {
        if (event.type != "pressmove") {
            return;
        }

        if (this.sliderBar.height > this.sliderBar.width) {
            this.verticalSlider(this.sliderBar.mouseY - (this.currentPos * this.sliderBar.height) / 100);
        }
        else {
            this.horizontalSlider(this.sliderBar.mouseX - (this.currentPos * this.sliderBar.width) / 100);
        }

        this.sliderMC.dispatchEvent(new Poker2SliderEvent("onSliding", this.currentPos, event.buttonDown));
    }
    private verticalSlider(changeY: number): void {
        var newY: number = int(this.buttonSlider.y + changeY);
        if(newY < this.sliderBar.y) {
            this.buttonSlider.y = this.sliderBar.y;
        } else if(newY < this.sliderBar.y + this.sliderBar.height) {
            this.buttonSlider.y = newY;
        } else {
            this.buttonSlider.y = this.sliderBar.y + this.sliderBar.height;
        }

        var sliderY: number = int(this.buttonSlider.y - this.sliderBar.y);
        var height: number = int(this.sliderBar.height);
        this.currentPos = 100 - ((height - sliderY) / height * 100);
    }
    private horizontalSlider(changeX: number): void {
        var newX: number = int(this.buttonSlider.x + changeX);
        if(newX < this.sliderBar.x) {
            this.buttonSlider.x = this.sliderBar.x;
        } else if(newX < this.sliderBar.x + this.sliderBar.width) {
            this.buttonSlider.x = newX;
        } else {
            this.buttonSlider.x = this.sliderBar.x + this.sliderBar.width;
        }

        var sliderX: number = int(this.buttonSlider.x - this.sliderBar.x);
        var SliderWidth: number = int(this.sliderBar.width);
        this.currentPos = 100 - ((SliderWidth - sliderX) / SliderWidth * 100);
    }

    protected onClickButtonUp(event: MouseEvent): void {
        if (!this.buttonUp.enabled)
            return;

        BasicController.getInstance().soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);

        this.currentPos = MathBase.min(100, this.currentPos + this.StepSize);
        this.updateSliderButton();
        this.sliderMC.dispatchEvent(new Poker2SliderEvent("slideUp", this.currentPos, event.buttonDown));
    }
    protected onClickButtonDown(event: MouseEvent): void {
        if (!this.buttonDown.enabled)
            return;

        BasicController.getInstance().soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);

        this.currentPos = MathBase.max(0, this.currentPos - this.StepSize);
        this.updateSliderButton();
        this.sliderMC.dispatchEvent(new Poker2SliderEvent("slideDown", this.currentPos, event.buttonDown));
    }
    private onClickSlider(event: MouseEvent): void {
        if (!this.buttonSlider.enabled)
            return;

        BasicController.getInstance().soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);

        if (this.sliderBar.height > this.sliderBar.width)
            this.verticalSlider(event.localY - (this.currentPos * this.sliderBar.height) / 100);
        else
            this.horizontalSlider(event.localX - (this.currentPos * this.sliderBar.width) / 100);

        this.sliderMC.dispatchEvent(new Poker2SliderEvent("onSliding", this.currentPos, event.buttonDown));
    }
    protected updateSliderButton(): void {
        if (this.buttonSlider) {
            if (this.sliderBar.height > this.sliderBar.width)
                this.buttonSlider.y = (this.sliderBar.height * this.currentPos / 100 + this.sliderBar.y);
            else
                this.buttonSlider.x = (this.sliderBar.width * this.currentPos / 100 + this.sliderBar.x);
        }
    }
    public initSlider(min: number, max: number, setvalue: number): void {
        setvalue = int(MathBase.max(min, MathBase.min(max, setvalue)));
        this.currentPos = (Math.ceil((setvalue - min) / ((max - min) / 100)));
        this.updateSliderButton();
    }

    public destroy(): void {
        if (this.buttonDown)
            this.buttonDown.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickButtonDown));
        if (this.buttonUp)
            this.buttonUp.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickButtonUp));
        if (this.buttonSlider)
            this.buttonSlider.removeEventListener(MouseEvent.MOUSE_DOWN, this.bindFunction(this.onSliderMouseDown));
        if (this.sliderBar)
            this.sliderBar.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickSlider));
    }

    public setVisible(flag: boolean): void {
        this.sliderMC.visible = flag;
    }

    public get mc(): MovieClip {
        return this.sliderMC;
    }
}
